import { Component } from '@angular/core';

@Component({
	selector: 'pp-home',
	templateUrl: './home.playground.html',
	styles: [],
	host: { class: 'pp-home' },
})
export class HomePlayground {}
